export const ROUTES = {
  LANDING: {
    path: "/",
    name: "Landing",
  },
  HOME: {
    path: "/home",
    name: "Home",
  },
  REQUEST_EMAILS: {
    path: "/requestEmails",
    name: "RequestEmails",
  },
  CATCH_SESSION: {
    path: "/session/:id/:cookie",
    name: "CatchSession",
  },
  REGISTER_APP: {
    path: "/registerApp",
    name: "RegisterApp",
  },
  DATA_VIZ: {
    path: "/dataViz",
    name: "Dataviz",
  },
  DETAILS_APP: {
    path: "/details/:name",
    name: "DetailsApp",
  },
  SEARCH: {
    path: "/search",
    name: "Search",
  },
  PROFILE: {
    path: "/profilePage",
    name: "profile",
  },
  SESSION_EXPIRED:{
    path:"/expired",
    name:"Expired",
  }
};
